import { Injectable, inject } from '@angular/core';
import { KeyValueIsUsedModel, KeyValuesCountryCodeModel } from '@models/common/keyValueModel';
import { MainUserNotificationDisable } from '@models/module/mainUserNotificationDisable';
import { UserEditProfileModel } from '@module-instance/user-profile/user-profile-info-form/userEditProfileModel';
import { UserSettingModel } from '@module-instance/user-profile/user-profile-info-form/userSettingModel';
import { HttpService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserProfileInfoFormService {
  http = inject(HttpService);

  getCountryCodes(): Observable<KeyValuesCountryCodeModel<string>[]> {
    return this.http.get<KeyValuesCountryCodeModel<string>[]>('_api/Main/CountryCodes', { useLoader: false });
  }

  getModulesWithNotificationStatus(contractId: number): Observable<KeyValueIsUsedModel<number, string>[]> {
    const params = this.http.buildHttpParams({ contractId });
    return this.http.get<KeyValueIsUsedModel<number, string>[]>('_api/Notification/GetModulesWithNotificationStatus', {
      useLoader: false,
      httpOptions: { params },
    });
  }

  uploadUserLogo(file: File): Observable<any> {
    const params = this.http.buildHttpParams({ mimeType: encodeURIComponent(file.type) });
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put<any>('_api/FolderFile/UploadFileAsUserLogo', formData, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  toggleLoadMore(): Observable<UserSettingModel> {
    return this.http.put<UserSettingModel>('_api/User/ToggleLoadMore', {}, { useLoader: false });
  }

  toggleShowLastVisitedModule(): Observable<UserSettingModel> {
    return this.http.put<UserSettingModel>('_api/User/ToggleShowLastVisitedModule', {}, { useLoader: false });
  }

  editProfile(model: UserEditProfileModel): Observable<UserEditProfileModel> {
    return this.http.put<UserEditProfileModel>('_api/User/EditProfile', model, { useLoader: false });
  }

  toggleGlobalNotification(isOn: boolean, contractId: number): Observable<MainUserNotificationDisable> {
    const params = this.http.buildHttpParams({ isOn: isOn ? 1 : 0, contractId });
    return this.http.put<MainUserNotificationDisable>(
      '_api/Notification/ToggleGlobalNotification',
      {},
      { useLoader: false, httpOptions: { params } },
    );
  }

  toggleModuleNotification(contractId: number, moduleId: number): Observable<MainUserNotificationDisable> {
    const params = this.http.buildHttpParams({ contractId, moduleId });
    return this.http.put<MainUserNotificationDisable>(
      '_api/Notification/ToggleModuleNotification',
      {},
      { useLoader: false, httpOptions: { params } },
    );
  }
}
